import { render, staticRenderFns } from "./accountantWrapper.vue?vue&type=template&id=52cc357e&"
import script from "./accountantWrapper.vue?vue&type=script&lang=js&"
export * from "./accountantWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports